export const PenaltyShotPlayer = {
  name: "penalty-shot-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "shot.select-player",
  showOn: [{ state: "primary", value: "penalty-shot-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: { value: "useHistory" },
  children: [
    {
      name: "foul-shot-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: false,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "clearData", value: ["flagged"], type: "main" },
            { action: "copyEvent", value: "penalty-shot", type: "to" },
            {
              action: "nextState",
              value: "penalty-shot-outcome",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "confirm-later-foul-shot-player",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "confirm-later",
          component: "TypeButton",
          layout: "match-button",
          mode: "enable",
          text: "confirmLater",
          showOn: [true],
          startEvent: false,
          startPlay: false,
          actionGroups: [
            {
              actions: [
                { action: "saveData", type: "flagged", value: true },
                { action: "clearData", value: ["personId"], type: "main" },
                { action: "copyEvent", value: "penalty-shot", type: "to" },
                {
                  action: "nextState",
                  value: "penalty-shot-outcome",
                  type: "primary",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
